import { createAction } from '@reduxjs/toolkit';
import { PACKAGE_NAME } from './constants';

export const submitShipping = createAction(`${PACKAGE_NAME}/submitShipping`);

export const unsubmitShipping = createAction(`${PACKAGE_NAME}/unsubmitShipping`);

/**
 * User asked to calculate the results of the current selection
 */
export const calculate = createAction(`${PACKAGE_NAME}/calculate`);

/**
 * User closed the current modal
 */
export const close = createAction(`${PACKAGE_NAME}/close`);
